<template>
  <div>
    <AboutUsNav></AboutUsNav>
    <div class="problem">
      <div class="problem_left" :class="{'problem_left_hover':left_hover}" id="f">
        <h3 class="about-h3-lx" @click="leftClick">联系我们</h3>
        <ul class="problem_left_title">
          <li><a href="/partner">招募合伙人</a></li>
          <li><a>拍界总部信息</a></li>
          <li style="padding-left:40px;" v-for="(item,indexli) in companies2" :key="item.id+'-a'" @click="toggleproTabs(indexli,0)" :class='{ current : showLi == indexli && showUl == 0 }'>{{item.title}}</li>
          <li><a>拍界分部信息</a></li>
          <li style="padding-left:40px;" v-for="(item,indexli) in branch_companies" :key="item.id+'-b'" @click="toggleproTabs(indexli,1)" :class='{ current : showLi == indexli && showUl == 1 }'>{{item.title}}</li>
        </ul>
      </div>
      <div class="problem_right">
        <ul class="problem_right_container" v-show="showUl === 0">
          <li class="problem_right_title">拍界总部信息</li>
          <li v-for="(item,indexli) in companies2" v-show="showLi === indexli" :key="item.id+'-c'">
            {{item.title}}
            <p v-if="item.name != undefined">联系人：{{item.name}}</p>
            <p>联系电话：{{item.phone}}</p>
            <p>地址：{{item.address}}</p>
            <p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
            <img v-for="(image,index) in JSON.parse(item.images)" :key="index+'-d'" :src="image.url" alt="">
            <div id="container" class="mymap" style="height:600px">
              <el-amap :center='center' :zoom='zoom'>
                <el-amap-marker v-for="(marker,index) in markers" :position="marker.position" :label="marker.label" :events="marker.events" :key="index+'-e'">
                </el-amap-marker>

                <el-amap-info-window v-for="(window,index) in windows" :position="window.position" :content="window.content" :visible="window.visible" :events="window.events" :key="index+'-f'">
                </el-amap-info-window>
              </el-amap>
            </div>
          </li>

        </ul>
        <ul class="problem_right_container" v-show="showUl === 1">
          <li class="problem_right_title">拍界分部信息</li>
          <li v-for="(item,indexli) in branch_companies" v-show="showLi === indexli" :key="item.id+'-g'">
            {{item.title}}
            <p v-if="item.name != undefined">联系人：{{item.name}}</p>
            <p>联系电话：{{item.phone}}</p>
            <p>地址：{{item.address}}</p>
            <p v-if="item.summary != undefined">介绍：{{item.summary}}</p>
            <img v-for="(image,index) in JSON.parse(item.images)" :key="index+'-h'" :src="image.url" alt="">
            <div id="container" class="mymap" style="height:600px">
              <el-amap :center='center' :zoom='zoom'>
                <el-amap-marker v-for="(marker,index) in markers" :key="index+'-i'" :position="marker.position" :label="marker.label" :events="marker.events">
                </el-amap-marker>

                <el-amap-info-window v-for="(window,index) in windows" :key="index+'-j'" :position="window.position" :content="window.content" :visible="window.visible" :events="window.events">
                </el-amap-info-window>
              </el-amap>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>



<script>
// import { formatDate } from '@/assets/js/date.js'
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      markers: [],
      showUl: 0,
      showLi: 0,
      windows: [],
      window: '',
      center: [123.436306609848, 42.81915342906472],
      zoom: 5,
      companies: [],
      companies2: [],
      smSwiperOptionMobile: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 3000,                      // 几秒播放一次
          disableOnInteraction: false       // 手动滑动后是否停止自动播放
        },
        loop: true,
        speed: 300									// 滚动速度
      },
      branch_companies: [],
      left_hover: 0,
    }
  },

  created () {

    // 接收路由参数
    const curLi = this.$route.query.curLi;
    const curUl = this.$route.query.curUl;
    if (curLi !== undefined && curUl !== undefined) {
      this.toggleproTabs(curLi, curUl)
    }

    this.axios.get("https://api.paijie.com/companies")
      .then((response) => {
        if (response.data.error.code == 0) {
          this.branch_companies = response.data.branch_companies;
          this.companies2 = response.data.companies;
          this.companies = this.branch_companies.concat(this.companies2);
          this.setMarkers(this.companies);
        }
      })
      .catch(() => { });

    // 显示公共栏
    this.$emit('header', true)
    this.$emit('footer', true)


  },

  // 方法属性
  methods: {
    setMarkers: function (companies) {
      let markers = [];
      let windows = [];
      let self = this;

      for (let i = 0; i < companies.length; i++) {
        markers.push({
          position: [companies[i].lng, companies[i].lat],
          label: {
            content: companies[i].title,
            offset: [20, 22]
          },
          events: {
            mouseover () {
              self.windows.forEach(window => {
                window.visible = false;
              });

              self.window = self.windows[i];
              self.$nextTick(() => {
                self.window.visible = true;
              });
            }
          }
        });

        if (companies[i].name == null) {
          companies[i].name = '拍界客服';
        }

        windows.push({
          position: [companies[i].lng, companies[i].lat],
          content:
            `<div class="prompt">
                        公司：${companies[i].title}
                    </div>
                    <div class="prompt">
                        电话：${companies[i].phone}
                    </div>
                    <div class="prompt">
                        联系人：${companies[i].name}
                    </div>
                    <div class="prompt">
                        位置：${companies[i].address}
                    </div>`,
          visible: false,
        });
      }

      this.markers = markers;
      this.windows = windows;
    },

    // tab切换
    toggleproTabs: function (showLi, showUl) {
      this.showLi = showLi;
      this.showUl = showUl;
      this.left_hover = 0;
    },
    leftClick: function () {
      this.left_hover = 1;
    }

  },
  mounted () {
    // 不是移动端则页面至顶部
    if (this.$route.query.isMobile == false) {
      window.scrollTo(0, 0)
    }

  },
  components: {
    AboutUsNav
  }

  // var infoWindow = new BMap.InfoWindow("地址：北京市东城区王府井大街88号乐天银泰百货八层", opts);  // 创建信息窗口对象
  //           marker.addEventListener("click", function () {
  //               map.openInfoWindow(infoWindow, point); //查看当前事件对象
  //           });
}


</script>
<style scoped>
@media screen and (max-width: 540px) {
  .problem_left {
    width: 42%;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 40px;
    position: absolute;
    z-index: 161;
    height: 50px;
    overflow: hidden;
    transition: height 1s;
    -moz-transition: height 1s; /* Firefox 4 */
    -webkit-transition: height 1s; /* Safari and Chrome */
    -o-transition: height 1s; /* Opera */
  }
  .problem_left_hover {
    height: 746px;
  }
  .problem_left {
    display: block;
  }
  .problem_right {
    display: block;
    width: 100%;
    margin-top: 20px;
  }
}
</style>